var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsisV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4px",
    height: "20px",
    viewBox: "0 0 4 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02_StockAwards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A_01",
    transform: "translate(-1026.000000, -362.000000)",
    fill: "#129FA9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Options/Primary",
    transform: "translate(1018.000000, 362.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.81818182,
    cy: 10,
    r: 1.81818182
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.81818182,
    cy: 1.81818182,
    r: 1.81818182
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.81818182,
    cy: 18.1818182,
    r: 1.81818182
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisV);
export default __webpack_public_path__ + "static/media/ellipsis-v.f0b86c4d4ef16aebad483244207a4909.svg";
export { ForwardRef as ReactComponent };